var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableICon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.5C0 4.25329 4.25329 0 9.5 0C14.7467 0 19 4.25329 19 9.5C19 14.7467 14.7467 19 9.5 19C4.25329 19 0 14.7467 0 9.5ZM13.0217 6.92825C13.3927 7.29925 13.3927 7.90077 13.0217 8.27174L9.52308 11.7704C8.98567 12.3078 8.11433 12.3078 7.5769 11.7704L5.97825 10.1717C5.60725 9.80077 5.60725 9.19923 5.97825 8.82825C6.34925 8.45728 6.95075 8.45728 7.32175 8.82825L8.55 10.0565L11.6783 6.92825C12.0492 6.55725 12.6508 6.55725 13.0217 6.92825Z",
    fill: "#2BA62C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableICon);
export default __webpack_public_path__ + "static/media/availableICon.54a0213bd8f34d1e07b0706d7be74f54.svg";
export { ForwardRef as ReactComponent };